@if (!isMobile) {
    <p-overlayPanel #op [dismissable]="true" [appendTo]="'body'" [showCloseIcon]="false" [styleClass]="'p-0'">
        <ng-container *ngTemplateOutlet="guideContent"></ng-container>
    </p-overlayPanel>
} @else {
    <p-sidebar #sidebar [(visible)]="sidebarVisible" [fullScreen]="true" [styleClass]="'mobile-quick-start-sidebar'"
               [showCloseIcon]="false" [appendTo]="'body'">
        <ng-container *ngTemplateOutlet="guideContent"></ng-container>
    </p-sidebar>
}

<ng-template #guideContent>
    <div [ngClass]="isMobile ? 'h-screen flex flex-column' : 'border-round-2xl shadow-6 w-full w-20rem md:w-22rem'">
        <!-- Header -->
        <div class="quick-start-header p-3" [ngClass]="isMobile ? 'flex-shrink-0' : 'text-white border-round-top-2xl'">
            <div class="flex align-items-center justify-content-between mb-2">
                <h3 class="m-0 text-lg font-semibold text-white">{{ guideTitle }}</h3>
                <p-button type="button" [text]="true"
                          (click)="hide()" [attr.aria-label]="completedSteps < maxSteps ? 'Minimize' : 'Close'">
                    <i class="pi text-white" [ngClass]="completedSteps < maxSteps ? 'pi-window-minimize' : 'pi-times'"></i>
                </p-button>
            </div>
            @if (!isAsapAccount) {
                <p class="m-0 text-sm text-white">Establish an effective SMS by completing your account setup.</p>
            }

            <!-- Progress pills -->
            <div class="flex align-items-center gap-2 mt-3" aria-hidden="true">
                @for (step of displaySteps; track step.step; let i = $index) {
                    <div
                        class="flex-1 border-round step"
                        [class.completed]="i < completedSteps">
                    </div>
                }
            </div>
        </div>

        <!-- Content wrapper -->
        <div [ngClass]="isMobile ? 'flex-1 overflow-auto' : 'quick-start-content-wrapper'">
            <!-- Body -->
            <div class="p-3 surface-card" [ngClass]="isMobile ? 'h-full' : 'border-round-bottom-2xl'">

                @for (step of displaySteps; track step.step) {
                    <div class="quick-start-step mb-3">
                        <button
                            type="button"
                            class="quick-start-header-btn w-full flex align-items-center justify-content-between p-3 border-round"
                            [class.active]="step.isOpen"
                            (click)="toggleSection(step.step)"
                            [attr.aria-expanded]="step.isOpen">
                            <div class="flex align-items-center gap-2">
                                @if (step.completed) {
                                    <img 
                                        src="assets/icons/green-check.svg" 
                                        alt="Completed" 
                                        width="16" 
                                        height="16"
                                        class="flex-shrink-0" />
                                } @else {
                                    <span class="border-circle w-1rem h-1rem surface-200 flex-shrink-0"></span>
                                }
                                <h4 class="m-0 text-base font-semibold"
                                    [ngClass]="!isMobile ? 'md:text-lg' : ''">{{ step.title }}</h4>
                            </div>
                            <i class="pi expand-icon" [ngClass]="step.isOpen ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
                        </button>

                        <div class="quick-start-content" [class.open]="step.isOpen"
                             style="background-color: var(--bg-body)">
                            <div class="p-3 border-round">
                                <p class="m-0 text-sm mt-2">
                                    {{ step.description }}
                                </p>
                                <p-button
                                    severity="secondary"
                                    type="button"
                                    styleClass="w-full mt-3"
                                    (click)="executeStepAction(step.step)"
                                    [disabled]="!isStepEnabled(step.step)"
                                    [label]="step.cta">
                                </p-button>
                                @if (step.canMarkNotApplicable && !step.completed) {
                                    <div class="text-center mt-2">
                                        <p-button 
                                                [link]="true"
                                                label="Mark as Not Applicable"
                                                styleClass="w-full mt-3"
                                                (click)="markAsNotApplicable(step.step)"
                                                [disabled]="step.completed"
                                                [attr.aria-disabled]="step.completed"
                                                [attr.tabindex]="step.completed ? -1 : 0">
                                        </p-button>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                }

            </div>
        </div>
    </div>
</ng-template>

